export const mergeMonthlyJournal = (local, remote) => {
  const normalizeEntry = (entry) => ({
    expectations: typeof entry?.expectations === 'string' ? entry.expectations : '',
    accomplished: typeof entry?.accomplished === 'string' ? entry.accomplished : '',
    updatedAt: typeof entry?.updatedAt === 'string' ? entry.updatedAt : (entry?.updatedAt ?? null)
  });
  const textLen = (entry) => `${entry.expectations}${entry.accomplished}`.trim().length;
  const asMap = (value) => (value && typeof value === 'object' && !Array.isArray(value) ? value : {});
  const localMap = asMap(local);
  const remoteMap = asMap(remote);
  const out = {};
  const keys = new Set([...Object.keys(remoteMap), ...Object.keys(localMap)]);
  keys.forEach((monthKey) => {
    const loc = localMap[monthKey] ? normalizeEntry(localMap[monthKey]) : null;
    const rem = remoteMap[monthKey] ? normalizeEntry(remoteMap[monthKey]) : null;
    if (!loc) {
      out[monthKey] = rem;
      return;
    }
    if (!rem) {
      out[monthKey] = loc;
      return;
    }
    const locAt = typeof loc.updatedAt === 'string' ? loc.updatedAt : '';
    const remAt = typeof rem.updatedAt === 'string' ? rem.updatedAt : '';
    if (locAt && remAt) {
      out[monthKey] = locAt >= remAt ? loc : rem;
      return;
    }
    // Legacy backups often have text but no updatedAt. Don't let a newer empty
    // cloud row wipe that text unless the local side is also empty.
    if (!locAt && remAt && textLen(rem) === 0 && textLen(loc) > 0) {
      out[monthKey] = loc;
      return;
    }
    if (locAt && !remAt && textLen(loc) === 0 && textLen(rem) > 0) {
      out[monthKey] = rem;
      return;
    }
    if (locAt && !remAt) {
      out[monthKey] = loc;
      return;
    }
    if (!locAt && remAt) {
      out[monthKey] = rem;
      return;
    }
    out[monthKey] = textLen(loc) >= textLen(rem) ? loc : rem;
  });
  return out;
};

export const latestCacheStamp = (...stamps) => {
  const valid = stamps.filter((s) => typeof s === 'string' && s && !Number.isNaN(new Date(s).getTime()));
  if (!valid.length) return new Date().toISOString();
  return valid.sort().at(-1);
};

export const shouldReplaceLocalCache = (existingSavedAt, incomingSavedAt) => {
  if (!existingSavedAt || !incomingSavedAt) return true;
  const prev = new Date(existingSavedAt).getTime();
  const next = new Date(incomingSavedAt).getTime();
  if (!Number.isFinite(prev) || !Number.isFinite(next)) return true;
  return next >= prev;
};
